// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2IqBh","title":"Info_title__3FT81","links":"Info_links__2X3mg","link":"Info_link__3Ym2P","logo":"Info_logo__2gC2V"};